import { HgsProductItem } from "./types";

function extractSKU(element: HTMLSpanElement): string {
  const regex = /Item #: (.+)/;
  const match = element.innerText.match(regex);
  return match ? match[1] : "";
}

/**
 *
 * @returns ItemsObject
 */
export function getProductFromPage(): HgsProductItem | null {
  const productContainer = document.querySelector(".product-container");

  if (!productContainer) {
    return null;
  }

  const priceText: HTMLSpanElement | null =
    productContainer.querySelector(".price");
  const skuElement: HTMLSpanElement | null =
    productContainer.querySelector(".code");
  const itemName: HTMLHeadingElement | null =
    productContainer.querySelector(".name");
  const imageEl: HTMLImageElement = productContainer.querySelector(
    "#product-img"
  ) as HTMLImageElement;
  const descriptionEl: HTMLDivElement = productContainer.querySelector(
    ".description"
  ) as HTMLImageElement;

  if (!priceText || !skuElement || !itemName) {
    throw new Error("Required elements not found");
  }

  let image,
    description = "";
  if (imageEl) {
    image = imageEl.src;
  }
  if (descriptionEl) {
    description = descriptionEl.innerText.replace(/\n/g, " ").trim();
  }

  const priceNumber = parseFloat(priceText.innerText.replace("$", ""));
  const sku = extractSKU(skuElement);

  return {
    item_id: sku,
    item_name: itemName.innerText,
    price: priceNumber,
    image: image,
    description: description,
  };
}

export function getQuantityFromPage(): number {
  const quantityInput: HTMLInputElement | null =
    document.querySelector("[id*=txtQty");

  const quantityNumber = quantityInput ? parseInt(quantityInput.value) : 1;
  return quantityNumber;
}

export function validateAttributeSelection(): boolean {
  const selectElement: HTMLSelectElement = document.querySelector(
    "[id*=AttributeName]"
  ) as HTMLSelectElement;
  let selectedOption = "";

  if (selectElement) {
    selectedOption = selectElement.options[selectElement.selectedIndex].value;
  }

  if (selectedOption === "-1") return false;

  return true;
}
